<template>
  <div id="coupons" class="comBag">
    <div class="personal-box comWidth">
    <CenterNav/>
    <div class="personal-right">
      <el-tabs v-model="activeName" >
        <el-tab-pane label="可使用的優惠券" name="first">
          <TabData :coupons="myCouponsList.list_1"/>
        </el-tab-pane>
        <el-tab-pane label="已使用的優惠券" name="second">
          <TabData :coupons="myCouponsList.list_2"/>
        </el-tab-pane>
        <el-tab-pane label="已失效的優惠券" name="third">
          <TabData :coupons="myCouponsList.list_3"/>
        </el-tab-pane>
      </el-tabs>
    </div>
    </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  //tab
  import TabData from '@/pages/personalPage/assetCenterPage/TabData'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  import {myCoupons} from '@/api/activity';
  export default {
    name: 'Coupons',
    components:{
      CenterNav,
      TabData
    },
    data () {
      return {
        activeName: 'first',
        myCouponsList:{list_1:[],list_2:[],list_3:[]},
      }
    },
    created(){
      this.getMyCouponsList(1)
      this.getMyCouponsList(2)
      this.getMyCouponsList(3)
    },
    methods:{
      getMyCouponsList(num){
        myCoupons(num).then(res =>{
          this.myCouponsList['list_' + num] = res.data.data
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/personalPage/assetCenterPage/Coupons.vue